import { AutoAwesome } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";
import CircularLoading from "components/CircularLoading";
import { ReactNode } from "react";

interface GenerateButtonProps extends ButtonProps {
  loading?: boolean;
  text?: string;
  customEndIcon?: ReactNode;
}

const GenerateButton = ({ loading, disabled, text, customEndIcon, ...props }: GenerateButtonProps) => {
  const isDisabled = loading || disabled;

  return (
    <Button
      variant='contained'
      endIcon={
        loading ? (
          <CircularLoading
            size={18}
            sx={{ py: 0, justifyContent: "flex-start" }}
          />
        ) : (
          customEndIcon || <AutoAwesome />
        )
      }
      sx={{ width: "fit-content" }}
      disabled={isDisabled}
      {...props}>
      {text || (loading ? "Генерация" : "Сгенерировать")}
    </Button>
  );
};

export default GenerateButton;
